<template>
	<div class="gfooter">
		<div class="text">
			<p space  = "emsp">Copyright © 2022 内蒙古艺术学院-面向边疆地区民族服饰产业的应用型人才培养模式改革和实践 教学成果奖 版权所有</p>
			<p space  = "emsp">地址：内蒙古呼和浩特市新城区新华东街101号 | 邮编：010010</p>
		</div>
	</div>
</template>

<script>
	export default {
		name:"gfooter",
		data() {
			return {
			};
		}
	}
</script>

<style lang="scss" scoped>
	.gfooter{
		
		width: 100%;
		height: 110px;
		background-color:#016285;
		font-size: 1.6ch;
		color: #eee;
        display: flex;
        justify-content: center;
        .text{
            margin-top: 20px;
			text-align: center;
        }
	}
</style>